import { useEffect, useRef, useState } from "react";
import { useInView, motion, useMotionValue, useTransform, animate } from "framer-motion";

// Animated number counter that activates when scrolled into view.
// If `static` is true (e.g. for year values like 2012), render the number without animation.
export default function StatCounter({ value, suffix = "", label, duration = 1.8, static: isStatic = false }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.floor(v));
  const [display, setDisplay] = useState(isStatic ? value : 0);

  useEffect(() => {
    if (isStatic) return;
    const unsub = rounded.on("change", setDisplay);
    return () => unsub();
  }, [rounded, isStatic]);

  useEffect(() => {
    if (isStatic) return;
    if (inView) {
      const controls = animate(count, value, { duration, ease: "easeOut" });
      return () => controls.stop();
    }
  }, [inView, value, count, duration, isStatic]);

  return (
    <div ref={ref} className="text-center" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl text-[#0a2540] tracking-tighter">
        {isStatic ? (
          <span>{value}</span>
        ) : (
          <motion.span>{display}</motion.span>
        )}
        <span className="text-[#ffde59]">{suffix}</span>
      </div>
      <div className="mt-2 text-xs sm:text-sm uppercase tracking-[0.2em] text-slate-500 font-semibold">
        {label}
      </div>
    </div>
  );
}
